<template>
  <div v-if="tabs.length" class="switch_tab_w align_item_c">
    <div class="desc_w c_808080 fz14">{{ desc }}</div>
    <div class="tabs_w c_1A1A1A">
      <div
        :class="!value ? 'active_tab fz14' : 'fz14'"
        class="tab_i"
        @click="_onTabClick('')"
      >
        {{ allText }}
      </div>

      <div
        v-for="item in tabs"
        :key="item.id"
        :class="item[valueKey] === value ? 'active_tab fz14 tab_i' : 'tab_i fz14'"
        @click="_onTabClick(item)"
      >
        {{ item[labelKey] }}
      </div>
    </div>
  </div>
</template>

<script>
import {isEmtry} from '@/utils'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: () => []
    },

    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    desc: {
      type: String,
      default: ''
    },
    allText: {
      type: String,
      default: '全部'
    }
  },
  data() {
    return {
      tabIndex: -1,
      loadEnd: false,
    }
  },
  created() {
    setTimeout(() => {
      this.loadEnd = true
    }, 1000)
  },
  methods: {
    _onTabClick(item) {
      this.$emit('input',item[this.valueKey])
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.switch_tab_w {
  display: flex;
  // align-items: center;
  padding: 0 10px;

  .active_tab {
    color: #fff;
    background: #0983CC;
  }
  .desc_w {
      margin: 17px 0;

    white-space: nowrap;
  }

  .tabs_w {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 0 0 20px;
    .all_w {
    }
    .tab_i {
      margin: 17px 0;
    }
    & > div {
      padding: 5px 14px;
      cursor: pointer;
    }
  }
}
</style>
